export default {
  TESTS: {
    TITLE: `Tests pour tâches récurrentes`,
    SUMMARY: ``
  },
  START: `Lancer`,
  LAST_RUN_AT: `Dernière exécution`,
  EXECUTION_TYPE: `Type d'exécution`,
  NOTIFICATION: `Type de notification`,
  RECURRENCE: `Récurrence`,
  TEST: `Test`,
  REGULAR: `Régulière`,
  CHECKEXPIREDAVAILABILITIES: `Vérification des disponibilités expirées`,
  CHECKEXPIREDAVAILABILITIES_DESC: `Vérifie si des employés ont une disponibilité qui expire entre 7 et 8 jours par rapport à la date d'aujourd'hui, et n'ont plus de disponibilité valide par la suite.`,
  CHECKEXPIREDAVAILABILITIES_RECURRENCE: `18-19h EST/EDT  tous les jours.`,
  CHECKEXPIREDAVAILABILITIES_NOTIFICATION_TYPE: `courriel, notification push`,
  CHECKPUNCHINOUT: `Vérification des poinçons IN et OUT`,
  CHECKPUNCHINOUT_DESC: `Vérifie si des employés ont poinçonné leur entrée ou sortie d'un quart de travail dans les 5 minutes après le début ou la fin de leur quart de travail.`,
  CHECKPUNCHINOUT_RECURRENCE: `toutes les 5 min.`,
  CHECKPUNCHINOUT_NOTIFICATION_TYPE: `notification push`,
  CHECKUNPUNCHEDSHIFTS: `Vérification des quarts de travail non poinçonnés`,
  CHECKUNPUNCHEDSHIFTS_DESC: `Envoie un courriel avec une liste des quarts de travail de la veille n'ont pas été poinçonnés.`,
  CHECKUNPUNCHEDSHIFTS_RECURRENCE: `2h-3h AM EST/EDT  tous les jours.`,
  CHECKUNPUNCHEDSHIFTS_NOTIFICATION_TYPE: `courriel`,
  EXPIRINGATTRIBUTESREMINDERS: `Rappel des attributs arrivant à expiration`,
  EXPIRINGATTRIBUTESREMINDERS_DESC: `Envoie un rappel à l'employé plusieurs jours (défini par l'administrateur) avant l'expiration de son attribut.`,
  EXPIRINGATTRIBUTESREMINDERS_RECURRENCE: `17-18h EST/EDT  tous les jours.`,
  EXPIRINGATTRIBUTESREMINDERS_NOTIFICATION_TYPE: `courriel, notification push, sms`,
  AVAILABILITYCUTOFFREMINDER: `Rappel de la date limite de soumission des disponibilités.`,
  AVAILABILITYCUTOFFREMINDER_DESC: `Envoie un rappel à l'employé entre 3h et 4h avant l'heure limite de soumission des disponibilités.`,
  AVAILABILITYCUTOFFREMINDER_RECURRENCE: `toutes les heures`,
  AVAILABILITYCUTOFFREMINDER_NOTIFICATION_TYPE: ` notification push`,
  SHIFTNOTIFICATION: `Rappel de quart de travail`,
  SHIFTNOTIFICATION_DESC: `Envoie un rappel à l'employé s'il est assigné à un/des quart(s) de travail le lendemain.`,
  SHIFTNOTIFICATION_RECURRENCE: `18-19h EST/EDT  tous les jours.`,
  SHIFTNOTIFICATION_NOTIFICATION_TYPE: ` notification push`,
  HAPPYBIRTHDAY: `Message de joyeux anniversaire`,
  HAPPYBIRTHDAY_DESC: `Envoie une notification push souhaitant joyeux anniversaire à tous les employés dont c'est l'anniversaire aujourd'hui.`,
  HAPPYBIRTHDAY_RECURRENCE: `8-9h AM EST/EDT  tous les jours.`,
  HAPPYBIRTHDAY_NOTIFICATION_TYPE: ` notification push`,
  DAILYQUESTIONNAIREREMINDER: `Rappel du questionnaire quotidien`,
  DAILYQUESTIONNAIREREMINDER_DESC: `Envoie une notification push aux employés n'ayant pas rempli le questionnaire dans le délai défini par l'admin (ou 24h par défaut)`,
  DAILYQUESTIONNAIREREMINDER_RECURRENCE: `16-17h EST/EDT  tous les jours.`,
  DAILYQUESTIONNAIREREMINDER_NOTIFICATION_TYPE: ` notification push`,
  CHECKEXPIREDHIRINGDATA: `Vérification des données d'embauches arrivant à expiration `,
  CHECKEXPIREDHIRINGDATA_DESC: `Envoie un courriel (défini dans les settings de la compagnie) avec la liste des employés avec données d'embauche expirant dans X jours (nombre défini dans settings ou 7 par défaut) par rapport à aujourd'hui. `,
  CHECKEXPIREDHIRINGDATA_RECURRENCE: `2h-3h AM EST/EDT  tous les jours.`,
  CHECKEXPIREDHIRINGDATA_NOTIFICATION_TYPE: `courriel`,
  PROJECTEMPLOYEECHANGESNOTIFICATIONS: `Vérification des employés retirés ou ajoutés à un projet`,
  PROJECTEMPLOYEECHANGESNOTIFICATIONS_DESC: `Envoie un courriel aux managers de chaque projet avec la liste des employés retirés ou ajoutés à leur(s) projet(s) dans lesd dernières 24h. `,
  PROJECTEMPLOYEECHANGESNOTIFICATIONS_RECURRENCE: `12h-1h AM EST/EDT tous les jours.`,
  PROJECTEMPLOYEECHANGESNOTIFICATIONS_NOTIFICATION_TYPE: `courriel`,
  UPDATEEXPIREDHIRINGDATA: `Mise à jour des données d'embauche`,
  UPDATEEXPIREDHIRINGDATA_DESC: `Met à jour automatiquement une donnée d'embauche expirée par celle qui a été choisie pour la remplacer (défini dans le formulaire de la donnée d'embauche).`,
  UPDATEEXPIREDHIRINGDATA_RECURRENCE: `12h-1h AM EST/EDT tous les jours.`,
  UPDATEEXPIREDHIRINGDATA_NOTIFICATION_TYPE: `aucune`,
  SYNCCHATUSERSTOTWILIO: `Synchronisation des utilisateurs de chat à Twilio`,
  SYNCCHATUSERSTOTWILIO_DESC: `Synchronise les utilisateurs de chat à Twilio.`,
  SYNCCHATUSERSTOTWILIO_RECURRENCE: `12h-1h AM EST/EDT tous les jours.`,
  SYNCCHATUSERSTOTWILIO_NOTIFICATION_TYPE: `aucune`,
  INTERCOMEVENTS: `Synchroniser les données des employés avec Intercom`,
  INTERCOMEVENTS_DESC: `Synchronise les données des employés avec intercom.`,
  INTERCOMEVENTS_RECURRENCE: `12h-1h AM EST/EDT tous les jours.`,
  INTERCOMEVENTS_NOTIFICATION_TYPE: `aucune`,
  WORKDAYSYNCSCHEDULE: `Synchroniser l'horaire de Workday`,
  WORKDAYSYNCSCHEDULE_DESC: `Synchroniser l'horaire de workday à Merinio`,
  WORKDAYSYNCSCHEDULE_RECURRENCE: `12h-1h AM EST/EDT tous les jours.`,
  WORKDAYSYNCSCHEDULE_NOTIFICATION_TYPE: `aucune`,
  ADDINTEGRATIONJOBS: `Lancer les intégrations`,
  ADDINTEGRATIONJOBS_DESC: `Lance les intégrations.`,
  ADDINTEGRATIONJOBS_RECURRENCE: `toutes les 15 min.`,
  ADDINTEGRATIONJOBS_NOTIFICATION_TYPE: `aucune`,
  FOLKSRHSYNCUSERS: 'Synchroniser les utilisateurs de FolksrH',
  FOLKSRHSYNCUSERS_DESC: 'Synchronise les utilisateurs de FolksrH',
  FOLKSRHSYNCUSERS_NOTIFICATION_TYPE: 'aucune',
  FOLKSRHSYNCUSERS_RECURRENCE: 'chaque 10 min.',
  CHANGESTATUSOFREPORT: `Change le statut des rapports en attente ou en traitement`,
  CHANGESTATUSOFREPORT_DESC: `Change le statut des rapports "en attente" ou "en traitement" après 24h au statut "échec"`,
  CHANGESTATUSOFREPORT_RECURRENCE: `1-2 AM EST/EDT  tous les jours.`,
  CHANGESTATUSOFREPORT_NOTIFICATION_TYPE: `aucune`,
  CREATEBILLINGLOGS: `Créer des logs de facturation`,
  CREATEBILLINGLOGS_DESC: `Exécute createBillingLogs vérifiant utilisateurs facturables`,
  CREATEBILLINGLOGS_RECURRENCE: `6 AM tous les jours`,
  CREATEBILLINGLOGS_NOTIFICATION_TYPE: `aucune`,
  CREATEBILLINGLOGSOLD: `Créer des logs de facturation (old)`,
  CREATEBILLINGLOGSOLD_DESC: `Exécute createBillingLogsOld vérifiant utilisateurs facturables`,
  CREATEBILLINGLOGSOLD_RECURRENCE: `6 AM tous les jours`,
  CREATEBILLINGLOGSOLD_NOTIFICATION_TYPE: `aucune`,
  RESETBILLABLETHISMONTH: `Réinitialise billableThisMonth`,
  RESETBILLABLETHISMONTH_DESC: `Mettre billableThisMonth false pour tous utilisateurs`,
  RESETBILLABLETHISMONTH_RECURRENCE: `5 AM 1er jour du mois`,
  RESETBILLABLETHISMONTH_NOTIFICATION_TYPE: `aucune`
}
